import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1150px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }
  .filter {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    align-items: flex-start;
  }

  .course {
    width: 100%;
    max-width: 320px;
    background-color: #f0f0f0;
    margin: 0 20px 20px 0;
    border-radius: 15px;
    padding-top: 10px;
    p {
      width: 100%;
      text-align: center;
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 10px;
    }
    img {
      width: 100%;
      max-height: 200px;
      object-fit: cover;
      background-color: #f6f6f6;
    }

    div {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        border-radius: 25px;
        margin: 0 5px;
        padding: 0 12px;
        height: 30px;
        font-size: 12px;
      }
    }
  }

  .courses {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .modules {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .title {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;

    h4 {
      text-align: left;
      font-size: 18px;
      color: #000;
      margin-right: 5px;
    }

    p {
      text-align: left;
      font-size: 13px;
      color: #000;
      margin-top: 5px;
      width: 100%;
    }
  }
`;
